import React, { useState } from "react";
import * as Sentry from "@sentry/react";
import Candidate from "../apiResources/Candidate";
import CandidateForm from "./CandidateForm";
import {
  Modal,
  ModalBackground,
  ModalContent,
  ModalClose,
  ModalHeading,
} from "./library/Modal";
import { FormError } from "./library/Form";

const CandidateEditModal = (props: Props) => {
  const { isOpen, onDismiss, onSuccess, candidate } = props;
  const [formError, setFormError] = useState("");

  if (!isOpen) return null;

  const initialValues = {
    ...candidate,
    hasDrivingLicence: candidate.hasDrivingLicence.toString(),
  };

  const updateCandidate = async (
    values: ReturnType<() => typeof initialValues>
  ) => {
    setFormError(null);

    try {
      candidate.assignAttributes(values);
      const success = await candidate.save();
      if (success) {
        onSuccess(candidate);
      } else {
        return candidate;
      }
    } catch (err) {
      setFormError("😬 Uh oh, something went wrong there!");
      Sentry.captureException(err);
    }

    return null;
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalBackground onClick={onDismiss} />
      <ModalContent>
        <ModalHeading>Edit Candidate</ModalHeading>
        {formError && <FormError>{formError}</FormError>}
        <CandidateForm
          initialValues={initialValues}
          onSubmit={updateCandidate}
        />
        <ModalClose onClick={onDismiss} aria-label="Close candidate modal" />
      </ModalContent>
    </Modal>
  );
};

type Props = {
  isOpen: boolean;
  candidate: Candidate;
  onDismiss: () => void;
  onSuccess: (candidate: Candidate) => void;
};

export default CandidateEditModal;
